// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"2311a03b","515":"487bd45f","517":"feff607b","905":"c2586b0a"}[chunkId] + ".chunk.css";
};